<div class="bg-[#0e365a] min-h-screen p-4">
  <!-- Barra de búsqueda -->
  <div class="mb-6">
    <div class="w-full md:w-1/3 flex items-center bg-white rounded-full px-4 py-2 shadow-sm">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-4.35-4.35M5 11a6 6 0 1112 0 6 6 0 01-12 0z" />
      </svg>
      <input 
        type="text" 
        [(ngModel)]="searchTerm" 
        (input)="onSearchChange()"
        placeholder="Buscar sucursales..."
        class="flex-1 outline-none placeholder:text-gray-400 bg-transparent">
    </div>
  </div>

  <!-- Cuadrícula de sucursales -->
  <div class="grid gap-2 md:gap-4" style="grid-template-columns: 1fr;" [style.grid-template-columns]="window.innerWidth >= 768 ? 'repeat(auto-fit, minmax(290px, 1fr))' : '1fr'">
    <app-branch-card
      *ngFor="let sucursal of sucursalesFiltradas"
      [nombre]="sucursal.nombre"
      [telefono]="sucursal.telefono"
      [calle]="sucursal.calle"
      [numeroInterior]="sucursal.num_int"
      [referencias]="sucursal.referencia"
      [cp]="sucursal.cp">
    </app-branch-card>
  </div>

  <!-- Mensaje cuando no hay resultados -->
  <div *ngIf="sucursalesFiltradas.length === 0 && searchTerm" class="text-center text-white mt-8">
    <p class="text-lg">No se encontraron sucursales que coincidan con "{{ searchTerm }}"</p>
  </div>
</div>
